import React from 'react';
import './CourseModuless.css';

const CourseModuless = () => {
  const courseModules = [
    {
      title: 'Basic Digital Marketing Course',
      points: [
        'Introduction to Digital Marketing',
        'SEO Basics',
        'Social Media Setup & Optimization',
        'Google My Business',
        'Email Marketing Fundamentals',
        'Content Marketing Introduction',
        'Avg Salary :  ₹35000/month',
        'Course Fees: ₹8,000 per month, payable for a duration of six months'
      ],
      jobSupport: '✅ 100% Job Support',
    },
    {
      title: 'Advanced Digital Marketing Course',
      points: [
        'Google Ads & PPC Campaigns',
        'Advanced SEO (On-page & Off-page)',
        'Facebook & Instagram Ads',
        'Conversion Rate Optimization',
        'Web Analytics with Google Analytics',
        'Marketing Funnel Strategies',
        'Avg Salary :  ₹50000/month',
        'Course Fees: ₹9,000 per month, payable for a duration of six months'
      ],
      jobSupport: '🎯 100% Job Guarantee',
    },
    {
      title: 'AI-Driven Digital Marketing Course',
      points: [
        'AI Tools for Marketers',
        'Content Creation using AI',
        'ChatGPT for Ads & Copywriting',
        'Automated Email Flows with AI',
        'Predictive Analytics & Data Tools',
        'AI-Based SEO Optimization',
        'Avg Salary :  ₹60000/month',
        'Course Fees: ₹10,000 per month, payable for a duration of six months'
      ],
      jobSupport: '🌍 100% Job Guarantee in India & Abroad',
    },
  ];

  return (
    <div className="coursemoduless-container">
      <h2 className="coursemoduless-title">Our Digital Marketing Course Tracks</h2>
      <div className="coursemoduless-grid">
        {courseModules.map((module, index) => (
          <div key={index} className="coursemoduless-box">
            <h3 className="coursemoduless-heading">{module.title}</h3>
            <ul className="coursemoduless-list">
              {module.points.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
            <div className="coursemoduless-jobsupport">{module.jobSupport}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseModuless;
